import { ButtonBase } from ".";
import { ACTION_STATUS } from "..";

export class DeleteButtonModel extends ButtonBase {
    label: string = 'Delete';
    action: string = ACTION_STATUS.delete;
    matIconName: string = 'delete';
    colorClass: string = 'color-primary-500';
}